<template>
  <div class="transition">
    <BasicText size="h5">
      Veuillez saisir les frais pour les frais de type
      <span>{{ props.in.natureFraisAnnexe.intitule }}</span>
      sur le
      <span>{{ props.in.module.intitule }}</span>
    </BasicText>
    <div class="transition-items">
      <WrapperInputNumber
        v-if="props.in.natureFraisAnnexe.baseCalcul === 'Quantite'"
        :label="props.in.natureFraisAnnexe.labelQuantite!"
        v-model="quantite"
        :decimal="0"
      />
      <WrapperInputNumber
        :label="props.in.natureFraisAnnexe.labelMontant"
        v-model="montant"
        :decimal="2"
      />
      <BasicAlert
        v-if="props.in.natureFraisAnnexe.baseCalcul === 'Quantite'"
        alert-label="Les champs laissés vides seront ignorés et conserveront leurs valeurs actuelles."
        alert-type="info"
      ></BasicAlert>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types.ts'
  import type { BatchUpdateResult } from '@/features/interface/demande/af/steps/frais/batchUpdate/BatchUpdateType.ts'
  import { computed } from 'vue'
  import { isNumber } from '@/features/shared/tools'

  type In = Pick<BatchUpdateResult, 'natureFraisAnnexe' | 'module'>
  type Out = Pick<BatchUpdateResult, 'montant' | 'quantite'>

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const montant = computed<number | undefined>({
    get: () => props.out?.montant,
    set: (value) => {
      const result: Partial<Out> = {
        ...props.out,
        montant: value,
      }
      emits('outChanged', validModele(result), result as Out)
    },
  })

  const quantite = computed<number | undefined>({
    get: () => props.out?.quantite,
    set: (value) => {
      const result: Partial<Out> = {
        ...props.out,
        quantite: value,
      }
      emits('outChanged', validModele(result), result as Out)
    },
  })

  const validModele = (modele: Partial<Out>) => {
    return isNumber(modele.montant) || isNumber(modele.quantite)
  }
</script>
<style lang="less" scoped>
  @import '@/features/interface/demande/ajouter/cartes/ChoixCarte.less';
  h5 span {
    font-weight: bolder;
    color: @primary-700;
  }
  .transition {
    max-width: max(30vw, 500px);
  }
  .transition-items {
    gap: 40px;
  }
</style>
